module.exports = "/packs/media/images/brands/edjones-68d31a3064fedd0af803ccc727ab7605.png";